"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var CheckboxAgree_1 = require("../checkboxAgree/CheckboxAgree");
var FormField_1 = require("../formField/FormField");
var FormFieldPhone_1 = require("../formFieldPhone/FormFieldPhone");
var FormSendButton_1 = require("../formSendButton/FormSendButton");
var formSpecialOffer_module_scss_1 = __importDefault(require("./formSpecialOffer.module.scss"));
var react_hook_form_1 = require("react-hook-form");
var customFetch_1 = require("../../helpers/customFetch");
var react_router_dom_1 = require("react-router-dom");
var ButtonCard_1 = require("../buttonCardOpenModal/ButtonCard");
var react_redux_1 = require("react-redux");
var modalSlice_1 = require("../../redux/slice/modalSlice");
var formatPrice_1 = require("../../helpers/formatPrice");
var getPayment_1 = require("../../helpers/car/getPayment");
var carDiscountCalculator_1 = __importDefault(require("../carDiscountCalculator/carDiscountCalculator"));
var react_google_recaptcha_1 = __importDefault(require("react-google-recaptcha"));
// Проверяем, нужна ли капча
var isCaptchaEnabled = process.env.CAPTCHA_ENABLED === 'true';
var FormSpecialOffer = function (props) {
    var _a, _b, _c;
    var brand = props.brand, model = props.model, car_catalog_configurations = props.car_catalog_configurations, setDiscount = props.setDiscount, discount = props.discount;
    var _d = (0, react_1.useState)(null), captchaToken = _d[0], setCaptchaToken = _d[1];
    var _e = (0, react_1.useState)(false), isShowCaptcha = _e[0], setShowCaptcha = _e[1];
    var dispatch = (0, react_redux_1.useDispatch)();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var defaultCarCatalog = ((_b = (_a = car_catalog_configurations[0]) === null || _a === void 0 ? void 0 : _a.configurations[0]) === null || _b === void 0 ? void 0 : _b.car_catalog_id) || undefined;
    var _f = (0, react_hook_form_1.useForm)({
        mode: 'onSubmit',
        defaultValues: {
            agree: true,
            car_catalog_id: defaultCarCatalog,
        },
        resolver: function (values) {
            var errorsResolver = {};
            if (!values.name) {
                errorsResolver.name = { type: 'required', message: 'Обязательное поле' };
            }
            if (!values.phone) {
                errorsResolver.phone = { type: 'required', message: 'Обязательное поле' };
            }
            if (!values.agree) {
                errorsResolver.phone = { type: 'required', message: 'Обязательное поле' };
            }
            return {
                values: values,
                errors: errorsResolver,
            };
        },
    }), register = _f.register, handleSubmit = _f.handleSubmit, errors = _f.formState.errors, reset = _f.reset;
    var onSubmit = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var dataQuery, successInformation, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (isCaptchaEnabled && !captchaToken) {
                        alert('Пожалуйста, подтвердите, что вы не робот.');
                        setShowCaptcha(true);
                        return [2 /*return*/];
                    }
                    dataQuery = {
                        car_catalog_order: {
                            car_catalog_id: data.car_catalog_id,
                            name: data.name,
                            phone: data.phone,
                            order_status_id: 1,
                        },
                    };
                    successInformation = {
                        user_name: data.name,
                        from: 'Заявка на обратный звонок принята',
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, (0, customFetch_1.customFetch)({ url: 'car_catalog_orders', data: JSON.stringify(dataQuery), method: 'POST' })];
                case 2:
                    _a.sent();
                    navigate('/success', { state: successInformation, replace: true });
                    reset();
                    setShowCaptcha(false);
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    console.log(error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement("div", { className: formSpecialOffer_module_scss_1.default.form_special__container },
        react_1.default.createElement("form", { className: formSpecialOffer_module_scss_1.default.form_special__form_container, onSubmit: handleSubmit(onSubmit) },
            react_1.default.createElement("div", { className: formSpecialOffer_module_scss_1.default.form_special__title },
                react_1.default.createElement("p", null,
                    "\u041F\u043E\u043B\u0443\u0447\u0438 \u0438\u043D\u0434\u0438\u0432\u0438\u0434\u0443\u0430\u043B\u044C\u043D\u043E\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u043D\u0430 \u043F\u043E\u043A\u0443\u043F\u043A\u0443",
                    react_1.default.createElement("span", null, " ".concat(brand, " ").concat(model)))),
            react_1.default.createElement("div", { className: formSpecialOffer_module_scss_1.default.form_special__form_items_wrapper },
                react_1.default.createElement(FormField_1.FormField, { id: "installment_your_name", placeholder: "\u0424\u0418\u041E", register: register('name', {
                        required: true,
                        minLength: {
                            value: 2,
                            message: 'Минимальная длина - 2 символа.',
                        },
                        pattern: {
                            value: /^[a-zA-Zа-яА-ЯёЁ\s-]+$/,
                            message: 'Используйте только буквы, пробел или дефис',
                        },
                    }), isError: Boolean(errors.name) }),
                react_1.default.createElement(FormFieldPhone_1.FormFieldPhone, { id: "installment_credit_phone", isError: Boolean(errors.phone), register: register }),
                react_1.default.createElement(CheckboxAgree_1.CheckboxAgree, { id: "installment_agree", isError: Boolean(errors.agree), register: register('agree', { required: true }) }),
                isCaptchaEnabled && isShowCaptcha && (react_1.default.createElement(react_google_recaptcha_1.default, { sitekey: (_c = process.env.REACT_APP_RECAPTCHA_SITE_KEY) !== null && _c !== void 0 ? _c : '', onChange: function (token) { return setCaptchaToken(token); } })),
                react_1.default.createElement(FormSendButton_1.FormSendButton, { textContent: "\u041F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0435" }))),
        react_1.default.createElement("div", { className: formSpecialOffer_module_scss_1.default.form_special__price_wrapper },
            react_1.default.createElement("div", { className: formSpecialOffer_module_scss_1.default.form_special__price_container },
                react_1.default.createElement("div", { className: formSpecialOffer_module_scss_1.default.form_special__main_price_container },
                    react_1.default.createElement("span", { className: formSpecialOffer_module_scss_1.default.form_special__car_price_full },
                        "\u043E\u0442 ",
                        (0, formatPrice_1.formatPrice)(car_catalog_configurations[0].configurations[0].price - discount),
                        " \u20BD"),
                    react_1.default.createElement("span", { className: formSpecialOffer_module_scss_1.default.form_special__month },
                        (0, formatPrice_1.formatPrice)((0, getPayment_1.getPayment)(car_catalog_configurations[0].configurations[0].price - discount, 0, 96, 0)),
                        "\u20BD/\u043C\u0435\u0441."),
                    react_1.default.createElement("span", null,
                        "\u0411\u0435\u0437 \u043F\u0435\u0440\u0432\u043E\u043D\u0430\u0447\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u0432\u0437\u043D\u043E\u0441\u0430 ",
                        react_1.default.createElement("span", null, "0\u20BD")))),
            react_1.default.createElement("div", { className: formSpecialOffer_module_scss_1.default.form_special__btn_wrapper },
                react_1.default.createElement(ButtonCard_1.ButtonCardOpenModal, { textContent: "\u041A\u0443\u043F\u0438\u0442\u044C \u0432 \u043A\u0440\u0435\u0434\u0438\u0442", handler: function () {
                        dispatch((0, modalSlice_1.openModal)('catalogOrder'));
                        dispatch((0, modalSlice_1.setOrderType)('credit'));
                    } }),
                react_1.default.createElement(ButtonCard_1.ButtonCardOpenModal, { textContent: "Trade-in", handler: function () {
                        dispatch((0, modalSlice_1.openModal)('catalogOrder'));
                        dispatch((0, modalSlice_1.setOrderType)('trade_in'));
                    } })),
            react_1.default.createElement(carDiscountCalculator_1.default, { car_catalog_configurations: car_catalog_configurations, setDiscount: setDiscount, discount: discount }))));
};
exports.default = FormSpecialOffer;
